import { applyOffset } from './timeSource';

const TIME_ENDPOINT = 'https://worldtimeapi.org/api/timezone/Etc/UTC';

export class NtpSyncError extends Error {
  constructor(message: string, public override readonly cause?: unknown) {
    super(message);
    this.name = 'NtpSyncError';
  }
}

interface WorldTimeApiResponse {
  readonly utc_datetime?: string;
}

export async function syncTime(endpoint: string = TIME_ENDPOINT): Promise<void> {
  const t0 = Date.now();
  let response: Response;
  try {
    response = await fetch(endpoint, { cache: 'no-store' });
  } catch (err) {
    throw new NtpSyncError('network request failed', err);
  }

  if (!response.ok) {
    throw new NtpSyncError(`time endpoint returned HTTP ${response.status}`);
  }

  let body: WorldTimeApiResponse;
  try {
    body = (await response.json()) as WorldTimeApiResponse;
  } catch (err) {
    throw new NtpSyncError('time endpoint returned invalid JSON', err);
  }

  if (!body.utc_datetime) {
    throw new NtpSyncError('time endpoint response missing utc_datetime');
  }

  const serverTime = Date.parse(body.utc_datetime);
  if (Number.isNaN(serverTime)) {
    throw new NtpSyncError(`time endpoint returned unparseable timestamp: ${body.utc_datetime}`);
  }

  const t1 = Date.now();
  const halfRoundtrip = (t1 - t0) / 2;
  const offset = serverTime + halfRoundtrip - t1;
  applyOffset(offset);
}
